var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsMultimedia24ClosePip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "multimedia/24/ic_close_pip") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "multimedia/24/ic_close_pip",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75690678,5.14569322 L12.0498,10.4378 L17.3426932,5.14569322 C17.7332175,4.75516893 18.3663825,4.75516893 18.7569068,5.14569322 C19.1474311,5.53621751 19.1474311,6.16938249 18.7569068,6.55990678 L13.4648,11.8528 L18.7569068,17.1456932 C19.1474311,17.5362175 19.1474311,18.1693825 18.7569068,18.5599068 C18.3663825,18.9504311 17.7332175,18.9504311 17.3426932,18.5599068 L12.0498,13.2678 L6.75690678,18.5599068 C6.36638249,18.9504311 5.73321751,18.9504311 5.34269322,18.5599068 C4.95216893,18.1693825 4.95216893,17.5362175 5.34269322,17.1456932 L10.6348,11.8528 L5.34269322,6.55990678 C4.95216893,6.16938249 4.95216893,5.53621751 5.34269322,5.14569322 C5.73321751,4.75516893 6.36638249,4.75516893 6.75690678,5.14569322 Z",
    id: "navigation/24/ic_cancel",
    fill: "#494A4A"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsMultimedia24ClosePip);
export default __webpack_public_path__ + "static/media/icons_multimedia_24_close_pip.d40096958b3fe7d8993a94a9ce583ad5.svg";
export { ForwardRef as ReactComponent };